import { Building2, Clock, PackageCheck, TrendingUp } from 'lucide-react';

import { StatCard } from '@/components/stat-card';

import { formatNumber } from '@/utils/format';

import { BreakdownPanel } from './sections/breakdown-panel';
import { useAnalyticsPage } from './use-analytics-page';

/**
 * Analytics dashboard view.
 * Shows the operational KPIs and the order breakdowns by country and status.
 */
export function AnalyticsPage() {
  const { summary, isLoading, isError } = useAnalyticsPage();

  if (isError) {
    return (
      <div className="flex justify-center p-8">
        <div className="alert alert-error max-w-lg">
          <span>No se pudieron cargar las analíticas. Intenta de nuevo.</span>
        </div>
      </div>
    );
  }

  if (isLoading || !summary) {
    return (
      <div className="flex justify-center p-16">
        <span className="loading loading-spinner loading-lg text-primary" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <header className="flex flex-col gap-1">
        <h1 className="text-3xl font-bold">Analíticas</h1>
        <p className="text-base-content/70">
          Indicadores de la operación de last mile del periodo en curso.
        </p>
      </header>

      <section className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard
          label="Órdenes del mes"
          value={formatNumber(summary.total_orders)}
          Icon={PackageCheck}
          tone="primary"
        />
        <StatCard
          label="Tasa de entrega"
          value={`${(summary.delivery_rate * 100).toFixed(1)}%`}
          Icon={TrendingUp}
          tone="success"
        />
        <StatCard
          label="Tiempo promedio"
          value={summary.average_delivery_hours > 0 ? `${summary.average_delivery_hours.toFixed(1)} h` : '—'}
          Icon={Clock}
          tone="info"
        />
        <StatCard
          label="Puntos activos"
          value={formatNumber(summary.active_dispatch_places)}
          Icon={Building2}
          tone="warning"
        />
      </section>

      <section className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <BreakdownPanel
          title="Órdenes por país"
          items={summary.orders_by_country}
          barClassName="bg-primary"
        />
        <BreakdownPanel
          title="Órdenes por estado"
          items={summary.orders_by_status}
          barClassName="bg-info"
        />
      </section>
    </div>
  );
}
